import { Button } from "@/components/ui/Button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { Textarea } from "@/components/ui/Textarea";
import { useAppContext } from "@/context/AppContext";
import { useLanguage } from "@/context/LanguageContext";
import { useMenuItemsContext } from "@/context/MenuItemsContext";
import { useEffect } from "react";

export function Support() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      bugReport: "Nahlásit chybu",
      featureRequest: "Požádat o novou funkci",
      description: "Zadejte detaily níže.",
      type: "Typ",
      message: "Zpráva",
      messagePlaceholder: "Vaše zpráva",
      discard: "Zahodit",
      submit: "Odeslat",
    },
    en: {
      bugReport: "Report a bug",
      featureRequest: "Request a new feature",
      description: "Enter details below.",
      type: "Type",
      message: "Message",
      messagePlaceholder: "Your message",
      discard: "Discard",
      submit: "Send",
    },
  }[language];
  const { isLoading, errorMessage } = useAppContext();
  const {
    handleDiscardChanges,
    saveNewFeatureRequest,
    selectedItem,
    newFeatureDetails,
    setNewFeatureDetails,
  } = useMenuItemsContext();

  useEffect(() => {
    setNewFeatureDetails((prev) => ({
      ...prev,
      type:
        selectedItem?.name === "Nahlásit chybu" ||
        selectedItem?.name === copy.bugReport
          ? "BUG"
          : "FEATURE",
    }));
  }, [copy.bugReport, selectedItem, setNewFeatureDetails]);
  const dialogTitle =
    selectedItem?.name === "Nahlásit chybu" ||
    selectedItem?.name === copy.bugReport
      ? copy.bugReport
      : copy.featureRequest;

  return (
    <DialogContent className="sm:max-w-[425px]">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          saveNewFeatureRequest();
        }}
        className="space-y-4"
      >
        <DialogHeader>
          <DialogTitle>{dialogTitle}</DialogTitle>
          <DialogDescription>{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="grid gap-3 py-4">
          <div className="hidden">
            <Label htmlFor="type" className="text-right">
              {copy.type}
            </Label>
            <Input
              disabled
              id="type"
              name="type"
              className="col-span-3"
              value={newFeatureDetails.type ?? ""}
              onChange={(e) =>
                setNewFeatureDetails((prev) => ({
                  ...prev,
                  type: e.target.value,
                }))
              }
            />
          </div>

          <div className="app-form-row">
            <Label htmlFor="message" className="text-right">
              {copy.message}
            </Label>
            <Textarea
              id="message"
              name="message"
              required
              placeholder={copy.messagePlaceholder}
              className="col-span-3"
              value={newFeatureDetails.message ?? ""}
              onChange={(e) =>
                setNewFeatureDetails((prev) => ({
                  ...prev,
                  message: e.target.value,
                }))
              }
            />
          </div>

          {errorMessage && (
            <div className="mt-2 font-semibold bg-red-50 p-2 rounded-md border border-red-200 text-center">
              <p className="text-sm text-red-500">{errorMessage}</p>
            </div>
          )}
        </div>

        <DialogFooter className="flex flex-row justify-end items-center gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={handleDiscardChanges}
            className="ml-2"
          >
            {copy.discard}
          </Button>
          <Button
            type="submit"
            disabled={isLoading}
            variant="default"
            className="relative"
          >
            {isLoading ? (
              <span className="dots">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </span>
            ) : (
              copy.submit
            )}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
}
